export const environment = {
  production: false,
  baseURL: 'https://temporarios.nectica.com/api',
  userKey: '!Nectica2023',
};
